// Generated by CoffeeScript 2.0.0-beta5
void function () {
  var pairRegex, toString;
  toString = Object.prototype.toString;
  pairRegex = /^\??([^=]*)=(.*)/;
  module.exports = function (str) {
    var keyPairs, keyVal, queryParams, tuple;
    if (null == str)
      str = window.location.search;
    if (!(toString.call(str) === '[object String]')) {
      if ('undefined' !== typeof JSON && null != JSON)
        str = JSON.stringify(str);
      throw new TypeError('Expected argument to be a string but got "' + str + '"');
    }
    queryParams = {};
    keyPairs = str.replace(/\+/g, '%20').split('&');
    for (var i$ = 0, length$ = keyPairs.length; i$ < length$; ++i$) {
      keyVal = keyPairs[i$];
      if (!(null != (tuple = pairRegex.exec(keyVal))))
        continue;
      try {
        queryParams[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
      } catch (e$) {
      }
    }
    return queryParams;
  };
}.call(this);
